var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"margin-top":"25px"}},[_c('QS-h4-title',{attrs:{"title":"企业租赁订单"}}),_vm._v(" "),_c('QS-common-table',{attrs:{"max-height":400,"data":_vm.tableData,"columns":_vm.columns,"pagination":false}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }